<template>
    <ul v-if="attributes && attributes.length" class="panel-tag" >
      <li v-for="(item, i) in attributes"  :key="i">
          <a v-if="item.href" class="tag secondary" :href="item.href">{{ item.displayName }}</a>
          <span v-else class="tag secondary" >{{ item.displayName }}</span>
      </li>
    </ul>
</template>

<script>
import { useAttribute } from './useAttribute.js';

export default {
name: 'MvtAttribute',
props: {
  data: {
    type: Array,
    default: () => [],
  },
},
setup(props) {
  const { state: { attributes, attrFavList} } = useAttribute(props.data);

  return {
    attributes,
    attrFavList
  };
},
};
</script>
